export type ProjectImage = {
  src: string;
  alt: string;
  caption: string;
};

export type Project = {
  slug: string;
  number: string;
  title: string;
  shortTitle: string;
  year: string;
  format: string;
  role: string;
  location: string;
  question: string;
  description: string;
  connection: string;
  methods: string[];
  outcomes: string[];
  image?: string;
  imageAlt?: string;
  gallery?: ProjectImage[];
  tone: "ink" | "rust" | "indigo" | "paper";
};

export const assets = {
  portrait: "/manus-storage/pawan-portrait_3b0c98da.jpeg",
  dastangoiStage: "/manus-storage/dastangoi-stage-optimized_db295e1a.webp",
  dastangoiIntimate: "/manus-storage/qissa-intimate_6ae6d817.webp",
  cv: "/manus-storage/pawan-sharma-academic-cv_7d52aa8c.pdf",
  movingTractsOverview: "/manus-storage/work-sample-000_69529cb3.png",
  soundStories: "/manus-storage/work-sample-001_21b4c4a4.png",
  movingCooking: "/manus-storage/moving-cooking_4b7c0c73.webp",
  movingLentils: "/manus-storage/moving-lentils_cfd87688.webp",
  movingWallText: "/manus-storage/moving-wall-text_267f5ebb.webp",
  movingFlowInstallation: "/manus-storage/moving-flow-installation_9a35f196.webp",
  movingFlowDetail: "/manus-storage/moving-flow-detail_a464422e.webp",
  movingSpiceCase: "/manus-storage/moving-spice-case_39b4e820.webp",
  movingSpecimenJars: "/manus-storage/moving-specimen-jars_d447b159.webp",
  movingSuspendedDetail: "/manus-storage/moving-suspended-detail_be69a733.webp",
  storiesInStillsPoster: "/manus-storage/stories-in-stills-poster_a2f685b9.webp",
  stormBranches: "/manus-storage/storm-branches_93e27841.webp",
  stormTrees: "/manus-storage/storm-trees_163ceb9f.webp",
  stormPineCity: "/manus-storage/storm-pine-city_71d52b45.webp",
  stormPlayground: "/manus-storage/storm-playground_dd032af0.webp",
  stormFence: "/manus-storage/storm-fence_05288bcf.webp",
  pawanStudio: "/manus-storage/pawan-studio_78a59d7a.jpg",
  pawanStudioLoop: "/manus-storage/pawan-studio-loop_10fa6488.mp4",
  counterVisionTitle: "/manus-storage/counter-vision-title_67cb0e70.jpg",
  familyPhotoArchive: "/manus-storage/family-photo-archive_26895589.jpg",
  movingTractsVideoCard: "/manus-storage/moving-tracts-video-card_cc55e7c1.jpg",
  georgeFloydMural: "/manus-storage/george-floyd-mural_cfb0cfa2.jpg",
  machineVisionInterface: "/manus-storage/machine-vision-interface_6c4d218c.jpg",
  withholdingDataMethod: "/manus-storage/withholding-data-method_ab0b2e72.jpg",
  machineVisionLoop: "/manus-storage/machine-vision-loop_d3fa38a0.mp4",
  qissaPerformanceLoop: "/manus-storage/qissa-performance-loop_8015d1fe.mp4",
  facesMarket: "/manus-storage/faces-market_0a063412.webp",
  facesSeated: "/manus-storage/faces-seated_3781fe51.webp",
  facesSubway: "/manus-storage/faces-subway_f961d186.webp",
  facesSaxophone: "/manus-storage/faces-saxophone_1e066f0a.webp",
  cityBench: "/manus-storage/city-bench_32fd88cf.webp",
  cityRedStreet: "/manus-storage/city-red-street_6eb06ae2.webp",
  cityWorkshop: "/manus-storage/city-workshop_12ef40e6.webp",
  cityFacade: "/manus-storage/city-facade_757b29c6.webp",
  cityFoodCart: "/manus-storage/city-food-cart_b449fc3f.webp",
  cityPots: "/manus-storage/city-pots_18ae2f42.webp",
  cinemaKolkataInterview: "/manus-storage/cinema-kolkata-interview_429bcf5d.webp",
  cinemaKolkataCounter: "/manus-storage/cinema-kolkata-counter_a64828e2.webp",
  cinemaKolkataFacade: "/manus-storage/cinema-kolkata-facade_1a702ad6.webp",
  cinemaIndoreProjector: "/manus-storage/cinema-indore-projector_0d291480.webp",
  cinemaIndorePoster: "/manus-storage/cinema-indore-poster_67c942f2.webp",
  cinemaIndoreDoorway: "/manus-storage/cinema-indore-doorway_278921d5.webp",
  cinemaIndoreExterior: "/manus-storage/cinema-indore-exterior_7c350a00.webp",
  cinemaIndoreTickets: "/manus-storage/cinema-indore-tickets_079b0096.webp",
  cinemaParkEntrance: "/manus-storage/cinema-park-entrance-thumb_11ff8349.webp",
  cinemaProjection: "/manus-storage/cinema-projection-thumb_7f965ba2.webp",
  foodFlamingGrid: "/manus-storage/food-flaming-grid_07337b54.webp",
  foodFlamingDiptych: "/manus-storage/food-flaming-diptych_29285f53.webp",
  foodAnnouncement: "/manus-storage/food-announcement-2_a146d19e.webp",
  foodAmsterdamGallery: "/manus-storage/food-amsterdam-gallery_ce5ac6b9.webp",
  foodPressureCooker: "/manus-storage/food-pressure-cooker-thumb_8d121c7c.webp",
  foodKitchen: "/manus-storage/food-kitchen-thumb_9c3fb883.webp",
  sewaLectern: "/manus-storage/sewa-lectern_750c8510.webp",
  sewaSpringCamp: "/manus-storage/sewa-spring-camp_dc8642a8.webp",
  sewaInterview: "/manus-storage/sewa-interview-thumb_e24b7adb.webp",
  sewaFoodService: "/manus-storage/sewa-food-service-thumb_19d98e80.webp",
  storiesFlyerSeven: "/manus-storage/stories-flyer-7_36356650.webp",
  extraordinaryTV: "/manus-storage/extraordinary-tv_c9efb0fb.jpg",
};

export const projects: Project[] = [
  {
    slug: "infrastructures-of-vision",
    number: "01",
    title: "Infrastructures of Vision",
    shortTitle: "Infrastructures of Vision",
    year: "In progress",
    format: "Dissertation · 50-minute documentary",
    role: "Researcher · director",
    location: "Malwa, central India",
    question: "Two years inside the everyday work of provincial media production.",
    description:
      "My dissertation follows single-screen theaters, informal distributors, local creators, and small production houses as they encounter streaming platforms, short-video apps, and inexpensive production software. I am interested in technological change as it appears through daily work: a projectionist keeping an aging theater open, a creator making regional humor legible to a recommendation system, or a studio combining wedding films, political content, music, and promotion to remain viable.",
    connection:
      "A fifty-minute documentary is part of the dissertation. Film records the pace, sound, space, and embodied labor of these media worlds, and returns the research to the people who made it possible.",
    methods: ["Ethnographic fieldwork", "Multilingual interviews", "Workplace observation", "Platform and policy analysis", "Documentary production"],
    outcomes: ["Multimodal dissertation", "Fifty-minute documentary in progress", "Forthcoming journal article and book chapter"],
    tone: "indigo",
  },
  {
    slug: "extraordinary-elsewhere",
    number: "02",
    title: "Extraordinary Elsewhere",
    shortTitle: "Extraordinary Elsewhere",
    year: "2025–2026",
    format: "Documentary · exhibition commission",
    role: "Director",
    location: "Minnesota",
    question: "Nine immigrant artists speak about displacement, paperwork, home, survival, and transformation.",
    description:
      "Produced for Rochester Art Center, Extraordinary Elsewhere follows nine immigrant artists living in Minnesota. Their practices move across dance, installation, sculpture, animation, poetry, storytelling, and performance. The film asks what artists carry across borders and what conditions allow them to keep making work.",
    connection:
      "During production I became more attentive to the afterlife of an image. A face, voice, studio location, timestamp, or biographical detail can move beyond a filmmaker’s intention. Iterative consent, participant review, careful framing, and selective abstraction became part of the film’s form.",
    methods: ["Documentary interviews", "Iterative consent", "Participant review", "Careful framing", "Selective abstraction"],
    outcomes: ["Rochester Art Center, 2025–2026", "Public television interview on KTTC / Midwest Access"],
    image: assets.extraordinaryTV,
    imageAlt: "Television interview about Extraordinary Elsewhere with a documentary image displayed in the studio",
    tone: "rust",
  },
  {
    slug: "moving-tracts",
    number: "03",
    title: "Moving Tracts: Cuisines, Cultures, Communities",
    shortTitle: "Moving Tracts",
    year: "2021–2023",
    format: "Photography · documentary · objects · sound",
    role: "Artist · researcher · exhibition designer",
    location: "Minneapolis · Berlin · Amsterdam · Lisbon · Goa",
    question: "Food becomes an archive of migration, labor, intimacy, and sensory memory.",
    description:
      "Moving Tracts began with conversations about the foods people carried, remembered, or learned to make after migration. Photography, short documentary, objects, sound, and QR-linked narratives brought those memories into the gallery without separating the ordinary act of cooking from colonial history, work, discrimination, and belonging.",
    connection:
      "The project moved through Minneapolis and artistic networks in Berlin, Amsterdam, Lisbon, and Goa. Each presentation changed the work because audiences brought their own food memories and migration histories into the room.",
    methods: ["Interviews", "Photography", "Short documentary", "Exhibition design", "Sound", "Object-based research"],
    outcomes: ["Coffman Art Gallery", "Presentations and artistic exchange across Europe and India"],
    image: assets.movingFlowInstallation,
    imageAlt: "A Moving Tracts installation in which lentils and peas flow from a wall-mounted form onto the gallery floor",
    gallery: [
      { src: assets.movingWallText, alt: "Wall text for the Moving Tracts exhibition", caption: "Moving Tracts · exhibition entrance · Coffman Art Gallery" },
      { src: assets.foodPressureCooker, alt: "A worn pressure cooker steaming on a stovetop", caption: "Food-memory film · pressure cooker" },
      { src: assets.foodKitchen, alt: "A person preparing ingredients at a kitchen counter", caption: "Food-memory film · kitchen portrait" },
      { src: assets.movingCooking, alt: "A hand stirring food in a metal pot during the Moving Tracts process", caption: "Food narrative process · cooking as memory and method" },
      { src: assets.movingLentils, alt: "Lentils spilling from a jute sack", caption: "Material study · pulses, jute, movement" },
      { src: assets.foodFlamingGrid, alt: "Four-panel image combining a hand, food in a jar, and colorful grid transformations", caption: "Flaming Bodies · experimental image study" },
      { src: assets.foodFlamingDiptych, alt: "A diptych of a seated person serving food in natural and transformed color", caption: "Flaming Bodies · documentary and chromatic states" },
      { src: assets.movingFlowInstallation, alt: "Lentils and peas spilling from an installation onto the gallery floor", caption: "Installation view · 2021" },
      { src: assets.movingSpiceCase, alt: "Spices and ingredients displayed in jute sacks below an artwork of hands", caption: "Installation detail · ingredients, labor, memory" },
      { src: assets.movingSpecimenJars, alt: "A row of glass specimen jars holding spices and dried ingredients", caption: "Installation detail · collected materials" },
      { src: assets.foodAmsterdamGallery, alt: "Visitors looking at food and hand photographs in a bright gallery", caption: "Moving Tracts · Amsterdam gallery documentation" },
    ],
    tone: "paper",
  },
  {
    slug: "immigrant-faces-new-york",
    number: "04",
    title: "Immigrant Faces of New York",
    shortTitle: "Immigrant Faces of New York",
    year: "2018–2021",
    format: "Photography · visual ethnography · exhibition",
    role: "Photographer",
    location: "New York · Minneapolis · Amsterdam",
    question: "A photographic study of how migrants read and inhabit public space.",
    description:
      "I began this series after moving to New York. The photographs followed work, waiting, transit, rest, and everyday encounters across public space. My own migration changed how I framed a face and how I thought about who has the authority to tell a story.",
    connection:
      "The project was presented at The New School, Coffman Art Gallery, and DAS Graduate School in Amsterdam. The images connect migration to the ordinary choreography of streets, transit, work, waiting, and rest.",
    methods: ["Street photography", "Long-form observation", "Visual ethnography", "Exhibition curation"],
    outcomes: ["The New School", "Coffman Art Gallery", "DAS Graduate School, Amsterdam"],
    image: assets.facesMarket,
    imageAlt: "A busy New York street market with fruit, vendors, shoppers, signs, and traffic",
    gallery: [
      { src: assets.facesMarket, alt: "A busy New York street market with fruit, vendors, shoppers, signs, and traffic", caption: "Immigrant Faces of New York · street market" },
      { src: assets.facesSeated, alt: "A person in a white shirt seated against a dark background", caption: "Immigrant Faces of New York · portrait study" },
      { src: assets.facesSubway, alt: "People moving through a broad public walkway near transit and food stands", caption: "Immigrant Faces of New York · public movement" },
      { src: assets.facesSaxophone, alt: "A saxophone player standing on a park path", caption: "Immigrant Faces of New York · music in public space" },
      { src: assets.cityRedStreet, alt: "A red New York streetscape with layered Chinese and English signs", caption: "Immigrant Faces of New York · street surface" },
      { src: assets.cityBench, alt: "Two people sharing opposite ends of a park bench", caption: "The Weight of Rest · 2018" },
    ],
    tone: "ink",
  },
  {
    slug: "counter-vision",
    number: "05",
    title: "Infrastructures of Counter-Vision",
    shortTitle: "Counter-Vision",
    year: "In development",
    format: "Research and protective-documentary toolkit",
    role: "Creator · researcher",
    location: "Minnesota / ongoing",
    question: "How do communities tell the truth when being visible can make them vulnerable?",
    description:
      "A voice can become biometric data. A face can become machine readable. A location can remain attached to an image. Counter-Vision begins from the problem that a story made to protect someone can later be used against them.",
    connection:
      "The project combines public narrative tracing with protective storytelling. It tests ways to reduce unnecessary machine-readable exposure while keeping testimony careful, truthful, and useful to the communities who produce it.",
    methods: ["Public narrative tracing", "Rotoscoped abstraction", "Audio recomposition", "Metadata minimization", "Revisitable consent"],
    outcomes: ["Toolkit in development", "Ongoing research in documentary ethics and machine vision"],
    tone: "indigo",
  },
  {
    slug: "impure-redemption",
    number: "06",
    title: "The Impure Redemption",
    shortTitle: "The Impure Redemption",
    year: "2014",
    format: "Malwi-language short fiction film",
    role: "Director",
    location: "Malwa, central India",
    question: "My first film, made in my native language and with people from my own region.",
    description:
      "I grew up in Malwa, where cinema reached me through local theaters, traveling screenings, pirated DVDs, and shared acts of watching. Making The Impure Redemption connected form with memory, labor, and the responsibility of representing a world I knew from within.",
    connection:
      "The place-based and collaborative method of this film continues through my documentary work, field research, and teaching.",
    methods: ["Malwi-language production", "Collaborative filmmaking", "Direction", "Place-based storytelling"],
    outcomes: ["Best Short Film, Nashik Film Festival", "International screenings"],
    tone: "rust",
  },
  {
    slug: "sound-stories",
    number: "07",
    title: "Sound Stories",
    shortTitle: "Sound Stories",
    year: "2022",
    format: "Interactive audiovisual work",
    role: "Audiovisual producer",
    location: "University of Minnesota",
    question: "Immigrant and refugee sonic memories move through a tactile interface, gallery, web, and social media.",
    description:
      "Sound Stories translated ethnographic material into short audiovisual pieces and tactile interaction. The work asked how a memory changes as it moves between a listening space, a screen, YouTube, and social circulation.",
    connection:
      "The project joined careful listening to practical questions about format, audience, and distribution.",
    methods: ["Audio production", "Interactive media", "Short-form editing", "Platform adaptation"],
    outcomes: ["Interactive audiovisual installation", "Platform-specific media series"],
    image: assets.soundStories,
    imageAlt: "A hand operating a tablet-based audiovisual interface beside recording equipment",
    tone: "ink",
  },
  {
    slug: "amber-visions",
    number: "08",
    title: "Amber Visions",
    shortTitle: "Amber Visions",
    year: "2024",
    format: "Generative-image exhibition",
    role: "Artist",
    location: "Homewood Studios, Minneapolis",
    question: "An experiment with generative images, authorship, and the gap between intention and automated output.",
    description:
      "Amber Visions gave me a place to work directly with generative images and digital form. I use AI as a creative material that still requires close judgment about authorship, data, labor, and the conditions under which an image circulates.",
    connection:
      "The exhibition became part of my wider inquiry into AI in documentary and visual practice.",
    methods: ["Generative-image experimentation", "Digital composition", "Critical making"],
    outcomes: ["Homewood Studios exhibition, 2024"],
    tone: "rust",
  },
  {
    slug: "cinema-ruins",
    number: "09",
    title: "Cinema Ruins",
    shortTitle: "Cinema Ruins",
    year: "2025–present",
    format: "Collaborative documentary",
    role: "Director",
    location: "India",
    question: "A film about single-screen cinemas, their decline, and the media life that continues around them.",
    description:
      "Cinema Ruins follows the spaces, workers, memories, and informal systems surrounding single-screen cinema in India. The film is in post-production and grows from repeated visits to theaters and production sites in Kolkata, Indore, and central India.",
    connection:
      "The project grows directly from my dissertation research on exhibition, access, informal circulation, and the social life of watching film together.",
    methods: ["Documentary fieldwork", "Site observation", "Interviews", "Archival research"],
    outcomes: ["Documentary in post-production"],
    image: assets.cinemaParkEntrance,
    imageAlt: "Weathered yellow and blue entrance area of a single-screen cinema",
    gallery: [
      { src: assets.cinemaParkEntrance, alt: "Weathered yellow and blue entrance area of a single-screen cinema", caption: "Park Show House · Kolkata · threshold" },
      { src: assets.cinemaIndoreExterior, alt: "Jyoti Cinema entrance with people on the steps", caption: "Jyoti Cinema · Indore · exterior" },
      { src: assets.cinemaIndoreDoorway, alt: "A dark cinema foyer opening toward a bright street", caption: "Jyoti Cinema · interior threshold" },
      { src: assets.cinemaIndoreTickets, alt: "Stacks of pink and blue printed cinema tickets", caption: "Cinema infrastructure · ticket bundles" },
      { src: assets.cinemaIndoreProjector, alt: "Close view of a mechanical film projector", caption: "Projection apparatus · Indore" },
      { src: assets.cinemaKolkataFacade, alt: "Weathered cinema facade embedded in a Kolkata street", caption: "Cinema and street life · Kolkata" },
      { src: assets.cinemaKolkataInterview, alt: "A documentary filming setup inside Jagat Talkies", caption: "Fieldwork interview · Jagat Talkies" },
      { src: assets.cinemaKolkataCounter, alt: "Ticket-counter grille with rate and schedule notices", caption: "Ticket counter · schedules, rates, access" },
      { src: assets.cinemaProjection, alt: "A projected film image in a dark auditorium mirrored by a phone screen", caption: "Projection and personal viewing" },
    ],
    tone: "ink",
  },
  {
    slug: "storm-minnesota",
    number: "10",
    title: "Storm, Minnesota",
    shortTitle: "Storm, Minnesota",
    year: "Photographic archive",
    format: "Photography",
    role: "Photographer",
    location: "Minnesota",
    question: "A winter study of streets, trees, snow, distance, and the unfamiliar work of learning a place.",
    description:
      "I arrived in Minnesota in 2019 knowing almost nothing about the state. This photographic archive stays with winter surfaces, empty streets, branches, public spaces, and the slow work of finding a visual language for a new place.",
    connection:
      "The images sit alongside my immigrant and public-space work, but they do not require another person to become visible in order to make place perceptible.",
    methods: ["Photography", "Observation", "Place study"],
    outcomes: ["Ongoing photographic archive"],
    image: assets.stormBranches,
    imageAlt: "Dark winter branches crossing a white Minnesota sky",
    gallery: [
      { src: assets.stormBranches, alt: "Dark tree branches crossing a white winter sky", caption: "Storm, Minnesota · branches" },
      { src: assets.stormTrees, alt: "Large trees standing in deep Minnesota snow", caption: "Storm, Minnesota · neighborhood trees" },
      { src: assets.stormPineCity, alt: "A pine branch in focus with a blurred city street behind it", caption: "Storm, Minnesota · pine and street" },
      { src: assets.stormPlayground, alt: "A snow-covered playground among winter trees", caption: "Storm, Minnesota · public space" },
      { src: assets.stormFence, alt: "Small winter plants seen through a wire fence", caption: "Storm, Minnesota · fence study" },
    ],
    tone: "paper",
  },
  {
    slug: "city-as-an-experience",
    number: "11",
    title: "City as an Experience",
    shortTitle: "City as an Experience",
    year: "2016–2018",
    format: "Photography · urban observation",
    role: "Photographer · researcher",
    location: "Ahmedabad · New York",
    question: "How does a city become visible through work, waiting, surfaces, movement, and ordinary use?",
    description:
      "This photographic study moves between Ahmedabad and New York through public encounters, shopfronts, workshops, benches, food carts, façades, and street-side spaces. The city is not treated as a skyline. It appears through the ways people occupy, maintain, pass through, and remember it.",
    connection:
      "The project connects my early visual research to later work on migration, public space, infrastructure, and the everyday conditions through which a place becomes legible.",
    methods: ["Street photography", "Urban observation", "Visual research", "Sequence and exhibition"],
    outcomes: ["Long-form photographic archive", "Foundation for later work on migration and public space"],
    image: assets.cityBench,
    imageAlt: "Two people sharing opposite ends of a park bench",
    gallery: [
      { src: assets.cityBench, alt: "Two people sharing opposite ends of a park bench", caption: "City as an Experience · rest and encounter" },
      { src: assets.cityRedStreet, alt: "A red streetscape with layered Chinese and English signs", caption: "City as an Experience · street surface" },
      { src: assets.cityWorkshop, alt: "Two people inside a densely packed open-front workshop", caption: "City as an Experience · work" },
      { src: assets.cityFacade, alt: "A weathered two-storey façade with pale shutters and dark columns", caption: "City as an Experience · built fabric" },
      { src: assets.cityFoodCart, alt: "A person pushing a handcart loaded with food through a narrow lane", caption: "City as an Experience · movement" },
      { src: assets.cityPots, alt: "A street-side area with earthenware pots and people at work", caption: "City as an Experience · material life" },
    ],
    tone: "rust",
  },
];

const featuredOrder = ["moving-tracts", "infrastructures-of-vision", "extraordinary-elsewhere", "storm-minnesota", "counter-vision", "sound-stories", "impure-redemption"];
export const featuredProjects = featuredOrder.map((slug) => projects.find((project) => project.slug === slug)!);

export const recognition = [
  ["2024–2025", "Wenner-Gren Dissertation Fieldwork Grant"],
  ["2024–2025", "Doctoral Dissertation Fellowship, University of Minnesota"],
  ["2023–2024", "Harold Leonard Memorial Fellowship in Film Study"],
  ["2022–2024", "Moving Image Studies Graduate Fellowship"],
  ["2025–2026", "Extraordinary Elsewhere · Rochester Art Center"],
  ["2024", "Amber Visions · Homewood Studios"],
] as const;

export const courses = [
  ["Spring 2026", "Digital Cultures and Storytelling", "Instructor of record and course designer"],
  ["Fall 2024", "Knowledge, Power and the Politics of Representation in Global Studies", "Instructor of record"],
  ["Spring 2023, 2022", "Korean Film and Media", "Teaching assistant"],
  ["Fall 2022", "Asian Film and Animation", "Teaching assistant"],
  ["2017–2018", "Photography Analogue and Digital", "Instructor"],
] as const;

export const publications = [
  { status: "Forthcoming", title: "The Unarchived Counterpublic: Algorithmic Visibility, Caste, and the Double Erasure of India’s TikTok", venue: "New Media & Society" },
  { status: "Forthcoming", title: "Circulating Politics, Creating Regional Political Subjectivity in Provincial India", venue: "Digital Leisure and the Work of Nation Building · Bloomsbury India" },
  { status: "In preparation", title: "The Logics of Visibility: Improvised Labor in India’s Provincial Digital Spaces", venue: "Article manuscript" },
  { status: "In preparation", title: "The Seasons Are Becoming Homeless", venue: "Climate change, solastalgia, and Hindi cinema’s meteorological grammar of desire" },
];

export const professionalEvidence = [
  { label: "Audience and media research", value: "1M–40M", detail: "Creator audiences represented in field research across TikTok, YouTube, Instagram, and local media networks." },
  { label: "Editorial publishing", value: "30K", detail: "Combined public reach of The Elsewhere Lab publication and podcast, managed from research through publication and audience engagement." },
  { label: "Program leadership", value: "100", detail: "Organizations connected through five years of Memory Movement Montage programs, partnerships, exhibitions, and public conversations." },
  { label: "Public programs", value: "15+", detail: "Workshops, conferences, exhibitions, screenings, and public programs led across institutions and countries." },
] as const;

export const navItems = [
  ["Work", "/practice"],
  ["Research", "/research"],
  ["Films & Art", "/films-art"],
  ["Teaching", "/teaching"],
  ["About", "/about"],
  ["CV", "/cv"],
  ["Contact", "/contact"],
] as const;
